import React, { createContext, useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  reportListData,
  getVisitorTypeList,
  getExtendedStayData,
  getAllReportedData,
} from "../../api/Api";
import RouteContants from "../../constants/routesContent.json";
import moment from "moment";
import dummyData from "../../constants/dummyData.json";
import { getAllDatesInRange } from "react-multi-date-picker";
// import { ReactReduxContext } from 'react-redux';

export const ReportContext = createContext({});
export const ReportContextProvider = ({ children }) => {
  const [filterCriteria, setFilterCriteria] = useState("Select");
  const [criteriaRequired, setCriteriaRequired] = useState(false);
  const [showDropdownList, setShowDropdownList] = useState(false);
  const [reportData, setReportData] = useState([]);
  const [pageCount, setPageCount] = useState(1);
  const [fromDate, setFromDate] = useState("From Date");
  const [toDate, setToDate] = useState("To Date");
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setcurrentPage] = useState(1);
  const [fromTime, setFromTime] = useState({
    id: "00%3A00%3A00",
    name: "From Time",
  });
  const [toTime, setToTime] = useState({ id: "23%3A59%3A59", name: "To Time" });
  const [visitorType, setVisitorType] = useState({ id: 0, name: "All" });
  const [reportSpinnerStatus, setReportSpinnerStatus] = useState(false);
  const [alert, setAlert] = useState(false);
  const [visitorTypeList, setVisitorTypeList] = useState("");
  const [statusCode, setStatusCode] = useState(0);
  const [extendedStayTime, setExtendedStayTime] = useState("");
  const navigate = useNavigate();

  const reportFilterData = async () => {
    if (fromDate == "" || toDate == "" || filterCriteria.id == undefined) {
      return;
    }

    const data = {
      page: currentPage,
      filter: filterCriteria.id,
      fromDate: fromDate[0] + " " + fromTime.id,
      toDate: toDate[0] + " " + toTime.id,
      category: visitorType.name,
    };
    setReportSpinnerStatus(true);
    try {
      const response = await reportListData(data);
      if (response?.status === 200) {
        setAlert(false);
        setReportSpinnerStatus(false);
        const filteredData = response?.data?.data;
        setReportData(filteredData);
        if (filterCriteria?.name === "Zone" && fromDate != "" && toDate != "") {
          setCriteriaRequired(false);
          navigate(RouteContants.REPORT_ZONE, {
            state: { filterCriteria, filteredData, currentPage },
          });
        }
        if (filterCriteria?.name === "All" && fromDate != "" && toDate != "") {
          
          setCriteriaRequired(false);
          navigate(RouteContants.REPORT_ZONE, {
            state: { filterCriteria, filteredData, currentPage },
          });
        }
        if (
          filterCriteria?.name.toLowerCase().split(" ")[0] === "visitors" &&
          fromDate != "" &&
          toDate != ""
        ) {
          setCriteriaRequired(false);
          navigate(RouteContants.VEHICLE_DETAILS, {
            state: { filteredData, visitorType },
          });
        }
        if (filterCriteria === "Select") {
          setCriteriaRequired(true);
        }
      }
    } catch (error) {
      setReportSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setAlert(true);
        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setAlert(true);
        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setAlert(true);
        setErrorMessage(error?.response?.data?.message);
      } else {
        setAlert(true);
        setErrorMessage("Something went wrong");
      }
    }
  };

  const createVisitorList = async () => {
    //Get Visitor List
    try {
      const getList = await getVisitorTypeList();
      if (getList.data.status === 200) {
        setAlert(false);
        setVisitorTypeList(getList?.data?.data?.visitorTypes);
      }
    } catch (error) {
      alert("error");
    }
  };

  const logout = () => {
    localStorage.removeItem("x-access-token");
    localStorage.removeItem("permissions");
    localStorage.removeItem("remember");
    navigate(RouteContants.LOGIN);
  };

  useEffect(() => {
    createVisitorList();
    reportFilterData();
    const formattedTime = moment()
      .subtract(1, "day")
      .format("YYYY-MM-DD HH:mm:ss");
    const convertTime = formattedTime.replace(/ /g, "%20").replace(/:/g, "%3A");
    setExtendedStayTime(convertTime);
  }, []);

  // when selected entended stay and submit page navigate to report table
  const onSubmitExtendedStay = async (page, time) => {
    setReportSpinnerStatus(true);
    try {
      const response = await getExtendedStayData({ page, time });
      if (response?.status === 200) {
        const extendData = response?.data?.data?.result?.data?.result;

        const pageNumbers = response?.data?.data?.result?.data?.numPages;

        navigate(RouteContants.REPORT_ZONE, {
          state: { filterCriteria, extendData, currentPage, pageNumbers, time },
        });
      }
    } catch (error) {
      setReportSpinnerStatus(false);
      setStatusCode(error?.response?.data?.status);
      if (error?.response?.data?.status === 400) {
        setAlert(true);
        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 401) {
        setAlert(true);
        setErrorMessage(error?.response?.data?.message);
      } else if (error?.response?.data?.status === 403) {
        setAlert(true);
        setErrorMessage(error?.response?.data?.message);
      } else {
        setAlert(true);
        setErrorMessage("Something went wrong");
      }
    }
  };

  const providerValue = {
    filterCriteria,
    setFilterCriteria,
    showDropdownList,
    setShowDropdownList,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    reportData,
    reportFilterData,
    criteriaRequired,
    setCriteriaRequired,
    alert,
    setAlert,
    errorMessage,
    reportSpinnerStatus,
    fromTime,
    setFromTime,
    toTime,
    setToTime,
    visitorType,
    setVisitorType,
    visitorTypeList,
    statusCode,
    logout,
    onSubmitExtendedStay, // extended stay submit function
    extendedStayTime, // state that store 24 hours converted time
    currentPage, // page number
  };
  return (
    <ReportContext.Provider value={providerValue}>
      {children}
    </ReportContext.Provider>
  );
};
